import store from '@store'

/**
 * 確保 merchant 已載入；若住宿功能未啟用則導向 404。
 * @returns {Promise<boolean>} 已處理導向時為 true（呼叫端不應再 next）
 */
export async function redirectIfHotelDisabled(next) {
  if (!store.state.merchant?.currentMerchant) {
    await store.dispatch('merchant/init')
  }
  if (!store.getters['merchant/hasHotelModule']) {
    next({ name: '404' })
    return true
  }
  return false
}
